module.exports = __webpack_public_path__ + "img/01_TC.4bfdc36a.png";